import { useState, useEffect } from 'react'

/*
 * Taken from: https://usehooks.com/useDebounce/
 */
const useDebounce = <T extends string | number>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

export { useDebounce }
